$(document).ready(function() {
  
  new WOW().init();
  	$(window).on("resize", function (e) {
        checkScreenSize();
    });

    $('#banner_slider').owlCarousel({
        margin: 0,
        loop: true,
        slideSpeed: 300,
        paginationSpeed: 400,
        autoplay: true,
        nav: false,
        pagination: false,
        dots: true,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        responsive: {
            0: {
                items: 1
            },
            480: {
                items: 1
            },
            700: {
                items: 1
            },
            1000: {
                items: 1
            },
            1100: {
                items: 1
            }
        }
    });

    $('.feature-slider').owlCarousel({
        margin: 10,
        loop: true,
        slideSpeed: 300,
        paginationSpeed: 400,
        autoplay: false,
        nav: true,
        center: true,
        pagination: false,
        dots: false,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        responsive: {
            0: {
                items: 1
            },
            480: {
                items: 1
            },
            768: {
                items: 2
            },
            1000: {
                items: 3
            },
            1100: {
                items: 4
            }
        }
    });
  
    setTimeout(function() {
        jQuery('.related-slider').owlCarousel({
            margin: 10,
            loop: true,
            slideSpeed: 300,
            paginationSpeed: 400,
            autoplay: false,
            nav: true,

            pagination: false,
            dots: false,
            navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            responsive: {
                0: {
                    items: 1
                },
                480: {
                    items: 1
                },
                768: {
                    items: 2
                },
                1000: {
                    items: 3
                },
                1100: {
                    items: 4
                }
            }

        });
    }, 3000);
  
    $(document).ready(function() {
        $(document).on("click", ".prev_trigger_btn", function() {
            $(this).closest("section").find(".owl-prev").trigger("click");

        });
        $(document).on("click", ".next_trigger_btn", function() {
            $(this).closest("section").find(".owl-next").trigger("click");
        });
    });
  
    // Loaction Tabbing Script
    $(document).on("click", ".location-tab-btn", function() {
        var id_tab = $(this).attr("data-val");
        $(".location-tab-btn").removeClass("active");
        $(this).addClass("active");

        $(".location-body-area").removeClass("active");
        $(".location-body-area." + id_tab).addClass("active");
    });
});